
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/video-privacy-policy/2024-07-31",
      function () {
        return require("private-next-pages/[locale]/legal/video-privacy-policy/2024-07-31.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/video-privacy-policy/2024-07-31"])
      });
    }
  